"use client";

import React from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../../context/AuthContext";
import StatsCard from "../../../../components/stats-card";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import styles from "../css/profileMenu.module.css";

const statsData = [
  { title: "Create Profile", icon: "user-plus" },
  { title: "Update Profile", icon: "edit-3" },
  { title: "Merge Profiles", icon: "repeat" },
  { title: "Split Profile", icon: "split" },
  { title: "Add Doctor", icon: "stethoscope" },
];

export function ProfileMenu() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const roleId = Number(user?.roleid);
  const isDirector = roleId === 2;

  return (
    <div className={styles.container}>
      <Navbar />
      <main className={styles.main}>
        <h1 className={styles.title}>Profile Menu</h1>
        <div className={styles.grid}>
          {(isDirector
            ? statsData.filter((s) =>
              s.title === "Create Profile" || s.title === "Add Doctor"
            )
            : statsData
          ).map((stat, index) => (
            <StatsCard
              key={index}
              title={stat.title}

              icon={stat.icon}
              variant="square"
              onClick={
                stat.title === "Create Profile"
                  ? () => navigate("/customer/profile/create")
                  : stat.title === "Update Profile"
                    ? () => navigate("/customer/profile/update")
                    : stat.title === "Merge Profiles"
                      ? () => navigate("/customer/profiles/merge-profiles")
                      : stat.title === "Split Profile"
                        ? () => navigate("/customer/profiles/split-profiles")
                        : stat.title === "Add Doctor"
                          ? () => navigate("/Profiles/add-doctor")
                          : undefined
              }
            />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ProfileMenu;